import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { toast as _rToast } from "react-toastify";
import { emitToast } from "./utils/toastEmitter";
import MuiToastContainer from "./components/MuiToastContainer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SignUp from "./pages/signup/SignUp";
import withMainLayout from "./withMainLayout";
import Dashboard from "./pages/dashboard/Dashboard";
import UserManagement from "./pages/usermanagement/UserManagement";
import VendorManagement from "./pages/vendormanagement/VendorManagement";
import Orders from "./pages/orders/Orders";
import ContentModration from "./pages/contentmodration/ContentModration";
import Report from "./pages/report/Report";
import EventManagement from "./pages/eventmanagement/EventManagement";
import PushNotification from "./pages/pushnotification/PushNotification";
import HelpAndSupport from "./pages/helpsupport/HelpAndSupport";
import Feedbacks from "./pages/feedbacks/Feedbacks";
import PaymentInfo from "./common/paymentinfo/PaymentInfo";
import UserPermission from "./common/userpermission/UserPermission";
import ModrationDetail from "./pages/contentmodration/detailview/ModrationDetail";
import VenderDetails from "./pages/vendormanagement/VenderDetails";
import UserInformation from "./pages/usermanagement/UserInformation";
import BlogDashboard from "./features/blog/pages/BlogDashboard";
import PostList from "./features/blog/pages/PostList";
import PostEditor from "./features/blog/pages/PostEditor";
import CategoryList from "./features/blog/pages/CategoryList";
import TagList from "./features/blog/pages/TagList";
import CommentList from "./features/blog/pages/CommentList";
import MediaLibrary from "./features/blog/pages/MediaLibrary";
import AnalyticsDashboard from "./features/blog/pages/AnalyticsDashboard";
import SeoSettings from "./features/seo/SeoSettings";
import RedirectManager from "./features/blog/pages/RedirectManager";
import ActivityLog from "./features/blog/pages/ActivityLog";
import SettingsPage from "./pages/settings/SettingsPage";

// Redirect all react-toastify calls to MUI system (module instance is shared across the bundle)
["success", "error", "warning", "warn", "info"].forEach((type) => {
  _rToast[type] = (msg) => emitToast(type, msg);
});
_rToast.dismiss = () => {};

function App() {
  return (
    <div className="App">
      <MuiToastContainer />
      <Router>
        <Routes>
          <Route path="/" element={<SignUp />} />

          <Route path="/dashboard" element={withMainLayout(Dashboard)()} />
          <Route
            path="/user-management"
            element={withMainLayout(UserManagement)()}
          />
          <Route
            path={`/user-management/user-information/:id`}
            element={withMainLayout(UserInformation)()}
          />
          <Route
            path="/vender-management"
            element={withMainLayout(VendorManagement)()}
          />
          <Route
            path="/vender-management/vender-details/:id"
            element={withMainLayout(VenderDetails)()}
          />
          <Route path="/all-order" element={withMainLayout(Orders)()} />
          <Route
            path="/content-moderation"
            element={withMainLayout(ContentModration)()}
          />
          <Route
            path="/content-moderation/details"
            element={withMainLayout(ModrationDetail)()}
          />
          <Route path="/report-analysis" element={withMainLayout(Report)()} />
          <Route
            path="/event-management"
            element={withMainLayout(EventManagement)()}
          />
          <Route
            path="/push-notification"
            element={withMainLayout(PushNotification)()}
          />
          <Route
            path="/help-support"
            element={withMainLayout(HelpAndSupport)()}
          />
          <Route path="/feedbacks" element={withMainLayout(Feedbacks)()} />
          <Route
            path="/payment-details"
            element={withMainLayout(PaymentInfo)()}
          />
          <Route
            path="/user-permission"
            element={withMainLayout(UserPermission)()}
          />
          <Route path="/blog" element={withMainLayout(BlogDashboard)()} />
          <Route path="/blog/posts" element={withMainLayout(PostList)()} />
          <Route
            path="/blog/posts/new"
            element={withMainLayout(PostEditor)()}
          />
          <Route
            path="/blog/posts/:postId/edit"
            element={withMainLayout(PostEditor)()}
          />
          <Route
            path="/blog/categories"
            element={withMainLayout(CategoryList)()}
          />
          <Route path="/blog/tags" element={withMainLayout(TagList)()} />
          <Route
            path="/blog/comments"
            element={withMainLayout(CommentList)()}
          />
          <Route path="/blog/media" element={withMainLayout(MediaLibrary)()} />
          <Route
            path="/blog/analytics"
            element={withMainLayout(AnalyticsDashboard)()}
          />
          <Route path="/seo" element={withMainLayout(SeoSettings)()} />
          <Route
            path="/blog/redirects"
            element={withMainLayout(RedirectManager)()}
          />
          <Route
            path="/blog/activity"
            element={withMainLayout(ActivityLog)()}
          />
          <Route path="/settings" element={withMainLayout(SettingsPage)()} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
